import { OfferType } from '@shared/constants';
import {
  AnyChallengeDTO,
  FrequencyChallengeDTO,
  ReferralChallengeDTO,
  SelectToWinChallengeDTO,
  StepChallengeDTO,
} from '@shared/dto';
import {
  FrequencyChallenge,
  ReferralChallenge,
  SelectToWinChallenge,
  StepChallenge,
} from '@shared/factory';
import { AnyChallenge } from '@shared/models';

export const formatChallenges = (
  response: AnyChallengeDTO[],
  campaignId: number
) => {
  const challenges: AnyChallenge[] = response.map((dto) => {
    switch (dto.type) {
      case OfferType.STEP:
        return new StepChallenge(campaignId, dto as StepChallengeDTO);
      case OfferType.FREQUENCY:
        return new FrequencyChallenge(campaignId, dto as FrequencyChallengeDTO);
      case OfferType.SPONSOR:
        return new ReferralChallenge(campaignId, dto as ReferralChallengeDTO);
      case OfferType.SELECT_TO_WIN:
        return new SelectToWinChallenge(
          campaignId,
          dto as SelectToWinChallengeDTO
        );
      default:
        console.warn(
          'Unknown challenge type:',
          dto.type,
          '... => Converting to StepChallenge'
        );
        return new StepChallenge(campaignId, dto as StepChallengeDTO);
    }
  });

  // Prioritize in-stock challenges
  return [
    ...challenges.filter((c) => !c.isOutOfStock()),
    ...challenges.filter((c) => c.isOutOfStock()),
  ];
};

/**
 * Shopper-facing name of a challenge, localised. `getChallengeName()` returns
 * the product scope's internal `name` (and the raw offer type for the other
 * kinds) — fine for tagging, never for display. Only step challenges carry a
 * scope, so the rest have no name of their own and yield an empty string.
 */
export const challengeLabel = (
  challenge: AnyChallenge,
  shortLocale: string
): string =>
  challenge instanceof StepChallenge
    ? `${challenge.productScope.label[shortLocale] ?? ''}`
    : '';
